import React from "react";
import { useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { NothingFilteredAlert, OrdersSummary, OrdersTable } from "@components/Statistics";
import { url_reverse } from "@components/Utils";

export default function StatisticsOrders({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:statistics:orders", { game_id: gameId }));
    const gameCommonInfo = useRouteLoaderData("gameCommonInfo");

    if (!apiData) return;

    const headerTools = apiData.object_list?.length > 0 && (
        <ExportButton
            size="sm"
            prms={{
                "filter-stats_period": apiData.forms_data.filter.data.stats_period,
                "filter-kind": apiData.forms_data.filter.data.kind,
            }}
        />
    );

    return (
        <ListingCard header={header} headerTools={headerTools} filterComponent={false}>
            <RenderForm prefix="filter" submitButtonText={t("Построить")} submitMethod="get" />
            <OrdersSummary />
            <NothingFilteredAlert />
            <OrdersTable forGame={true} devId={gameCommonInfo.developer.id} />
        </ListingCard>
    );
}
